import moment from "moment";
import React, { useState, useEffect, useRef } from "react";
import { Attendance, FR } from "../../sdk";
import { Loader } from "../Default";
import { assetUrl } from "../../helpers";
import { DataTable2 } from "../Default/DataTables/DataTable2";
import { useAuthContext } from "../../context/Auth/Create";
import { DataTable } from "../Default/DataTables/DataTable";
import { SearchableSelectBox } from "../Default/SearchableSelectBox";
export const DateWiseSearch = () => {
  const userAuth = useAuthContext();

  const [state, setState] = useState({
    loader: true,
    selectFilter: false,
    date: moment().subtract(1, "day").format("yyyy-MM-DD"),
    year: new Date().getFullYear(),
    month: Number(new Date().getMonth()),
    employeeId: "",
    tableLoader: false,
    tbHeader: [
      { title: "Date", name: "date" },
      { title: "Day", name: "day" },
      { title: "ID", name: "employeeId" },
      { title: "Name", name: "employeeName" },
      { title: "Company Name" },
      { title: "Department", name: "department" },
      { title: "CheckIn" },
      { title: "CheckOut" },
      { title: "Required Hours" },
      { title: "Worked Hour" },
      { title: "Excess/ShortTime" },
      { title: "Status" },
    ],
    tbHeader2: [
      { title: "ID", name: "employeeId", data: "employeeId" },
      { title: "Name", name: "employeeName", data: "employeeName" },
      { title: "Date", name: "date", data: "date" },
      {
        title: "CheckIn",
        data: "employeeId",
        render: function (data, type, row) {
          return row.checkIn ? row.checkIn : "";
        },
      },
      {
        title: "CheckOut",
        name: "CheckOut",
        data: "employeeId",
        render: function (data, type, row) {
          return row.checkOut ? row.checkOut : "";
        },
      },
      {
        title: "cameraId",
        name: "cameraId",
        data: "employeeId",
        render: function (data, type, row) {
          return row.cameraId ? row.cameraId : "";
        },
      },
      {
        title: "Image",
        data: "employeeId",
        render: function (data, type, row) {
          return row.imageName && row.imageName != ""
            ? `<a href=${assetUrl}${row.imageName} target='_blank'><img src=${assetUrl}${row.imageName} style="width:100%"; /></a>`
            : "mannual attendnce";
        },
      },
    ],
    data: [],
    data2: [],
    tableLoader2: true,
    companyName: userAuth.user.isHightAuthority
      ? userAuth?.user.companyName
      : "",
    department: "",
    companies: [],
    departments: [],
    employees: [],
  });
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  const ref4 = useRef({
    employeeId: "",

    date: moment().subtract(1, "day").format("yyyy-MM-DD"),
    companyName: userAuth.user.isHightAuthority
      ? userAuth?.user.companyName
      : "",
    year: new Date().getFullYear(),
    month: Number(new Date().getMonth()),
    department: "",
    companies: [],
    departments: [],
    dataTable1Params: {
      draw: 1,
      start: 0,
      length: 0,
      search: "",
      order: "",
      columns: "",
      sort: "asc",
    },
    dataTable2Params: {
      draw: 1,
      start: 0,
      length: 0,
      search: "",
      order: "",
      columns: "",
      sort: "asc",
    },
  });

  function convertHoursToHHMM(seconds) {
    const duration = moment.duration(seconds, "seconds");
    const formattedTime = `${Math.floor(duration.asHours()).toString().padStart(2, "0")}:${duration.minutes().toString().padStart(2, "0")}:${duration.seconds().toString().padStart(2, "0")}`;
    return formattedTime;
  }
  const validateFilters = () => {
    if (!ref4.current.companyName) {
      alert("Please select Company");
      return false;
    }

    if (!ref4.current.department) {
      alert("Please select Department");
      return false;
    }

    if (!ref4.current.employeeId) {
      alert("Please select Employee ID");
      return false;
    }

    return true;
  };
  const apiDataWithPagination = async (
    data,
    callBack2,
    companyName = ref4.current.companyName,
    department = ref4.current.department,
    year = ref4.current.year,
    month = ref4.current.month,
    employeeId = ref4.current.employeeId,
    initialLoad = false,
  ) => {
    try {
      ref4.current = {
        ...ref4.current,
        dataTable2Params: {
          draw: data?.draw,
          start: data?.start,
          length: data?.length,
          search: data?.search?.value || "",
          order: data?.order,
          columns: data?.columns,
          sort: data?.sort,
        },
        callBack2,
      };
      if (!initialLoad) {
        return;
      }

      if (!companyName) {
        alert("Please select Company");
        return;
      }

      if (!department) {
        alert("Please select Department");
        return;
      }

      if (!employeeId) {
        alert("Please select Employee ID");
        return;
      }

      setState((pre) => {
        return { ...pre, tableLoader: true };
      });

      let apiData = {
        draw: data?.draw,
        start: data?.start,
        length: data?.length,
        search: data?.search?.value || "",
        order: data?.order,
        columns: data?.columns,
        sort: data?.sort,
        companyName,
        department,
        month,
        year,
        employeeId,
      };
      let users = await new Attendance().userWiseData({ ...apiData });
      let arr = [];
      if (users.length) {
        for (let val of users) {
          arr.push([
            val.date,
            val.day,
            val.employeeId,
            val.employeeName,
            val.companyName,
            val.department,
            val.checkIn ? val.checkIn : "",
            val.checkOut ? val.checkOut : "",
            convertHoursToHHMM(val.totalRequiredHours),
            convertHoursToHHMM(val.workedHours),
            val.totalRequiredHours > val.workedHours
              ? `-${val.shortExactTime}`
              : val.shortExactTime,
            val.status,
          ]);
        }
      }

      setState((pre) => {
        return { ...pre, data: arr, tableLoader: false };
      });
    } catch (e) {
      console.log(e);
      alert("error occur");
    }
  };

  const apiData2WithPagination = async (
    data,
    callBack,
    employeeId = ref4.current.employeeId,
  ) => {
    try {
      setState((pre) => {
        return { ...pre, tableLoader2: true };
      });
      ref4.current = {
        ...ref4.current,
        employeeId,
        dataTable1Params: {
          draw: data?.draw,
          start: data?.start,
          length: data?.length,
          search: data?.search?.value || "",
          order: data?.order,
          columns: data?.columns,
          sort: data?.sort,
        },
        callBack,
      };

      let apiData = {
        type: "Employee",
        draw: data?.draw,
        start: data?.start,
        length: data?.length,
        search: data?.search?.value || "",
        order: data?.order,
        columns: data?.columns,
        sort: data?.sort,
        date: ref4.current.date,
        employeeId: String(employeeId),
      };
      if (employeeId === "") {
        return;
      }
      let users = await new FR().employeeAttendanceDetailsWithpagination({
        ...apiData,
      });
      ref4.current.callBack(users);
      setState((pre) => {
        return { ...pre, tableLoader2: false };
      });
    } catch (e) {
      console.log(e);
      alert("error occur");
    }
  };
  const apiData = async () => {
    try {
      let users = await new FR().getCompanies();
      let departments = [];
      let find = users.find((val) => val.companyName === state.companyName);
      if (find) {
        departments = find.departments;
      }

      setState((pre) => {
        return { ...pre, companies: users, loader: false, departments };
      });
    } catch (e) {
      console.log(e);
      alert("error occur");
    }
  };

  const onDetails = (employeeId) => {
    apiData2WithPagination(
      {
        ...ref4.current,
        draw: ref4.current.dataTable1Params.draw,
        length: 10,
        start: 0,
        search: "",
      },
      ref4.current.callBack,
      employeeId,
    );
    window.$("#showImg").modal("show");
  };
  const onHandlerType = async (event) => {
    let key = event.target.name;
    let value = event.target.value;
    if (key === "companyName" || key === "department") {
      let departments = [];
      let employees = [];
      let department = state.department;

      if (key === "companyName") {
        if (value === "N/A") {
          setState((pre) => {
            return { ...pre, selectFilter: true };
          });
          let getEmployees = await new FR().getAllData({
            status: 1,
            department: value,
            companyName: value,
          });
          employees = getEmployees.map((val) => {
            return {
              id: val.employeeId,
              name: `${val.firstName} ${val.middleName || ""} ${val.lastName || ""}`,
            };
          });
          setState((pre) => {
            return { ...pre, selectFilter: false };
          });
        } else {
          let find = state.companies.find((val) => val.companyName === value);
          if (find) {
            departments = find.departments;
          }
          department = "";
        }
      }

      if (key === "department") {
        if (value !== "") {
          setState((pre) => {
            return { ...pre, selectFilter: true };
          });
          let getEmployees = await new FR().getAllData({
            status: 1,
            department: value,
            companyName: ref4.current.companyName,
          });
          employees = getEmployees.map((val) => {
            return {
              id: val.employeeId,
              name: `${val.firstName} ${val.middleName || ""} ${val.lastName || ""}`,
            };
          });
          setState((pre) => {
            return { ...pre, selectFilter: false };
          });
        }

        departments = state.departments;
        department = value;
      }
      ref4.current = {
        ...ref4.current,
        [key]: value,
        department: state.department,
        employeeId: "",
        department,
      };
      setState((pre) => {
        return { ...pre, [key]: value, departments, employees, department };
      });
    } else {
      ref4.current = { ...ref4.current, [key]: value };
      setState((pre) => {
        return { ...pre, [key]: value };
      });
    }
  };
  const onSearchHandle = (value) => {
    ref4.current.employeeId = value;
    setState((pre) => {
      return { ...pre, employeeId: value };
    });
  };
  useEffect(() => {
    apiData();
  }, []);
  if (!state.loader) {
    return (
      <>
        <div className="card mb-3">
          {/* BEGIN card-body */}
          <div className="card-body">
            <div
              className="d-flex fw-bold small mb-3 row"
              style={{ textAlign: "center" }}
            >
              <div className="col-12">
                <span className="flex-grow-1">User Wise Report</span>
              </div>
              <div className="col-sm-12 col-md-3 col-lg-2">
                <div class="form-group mb-3">
                  <label
                    class="form-label text-white fw-bold"
                    for="exampleFormControlSelect1"
                  ></label>
                  <select
                    class="form-select"
                    name="companyName"
                    id="exampleFormControlSelect1"
                    onChange={onHandlerType}
                    style={{ color: "rgb(60, 210, 165)" }}
                  >
                    <option value="" selected={ref4.current.companyName === ""}>
                      Company
                    </option>
                    {state.companies.map((val, index) => {
                      return (
                        <option
                          key={index}
                          value={val.companyName}
                          selected={
                            ref4.current.companyName === val.companyName
                          }
                        >
                          {val.companyName}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-sm-12 col-md-3 col-lg-2">
                <div class="form-group mb-3">
                  <label
                    class="form-label text-white fw-bold"
                    for="exampleFormControlSelect2"
                  ></label>
                  <select
                    class="form-select"
                    name="department"
                    id="exampleFormControlSelect2"
                    onChange={onHandlerType}
                    style={{ color: "rgb(60, 210, 165)" }}
                  >
                    <option value="" selected={ref4.current.companyName === ""}>
                      Department
                    </option>
                    {state.departments.map((val, index) => {
                      return (
                        <option
                          key={index}
                          value={val}
                          selected={ref4.current.department === val}
                        >
                          {val}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              {state.selectFilter && <Loader />}
              <div className="col-sm-12 col-md-3 col-lg-3">
                <div class="form-group mb-3">
                  <SearchableSelectBox
                    data={state.employees}
                    onSearchHandle={onSearchHandle}
                    selected={ref4.current.employeeId}
                  />
                </div>
              </div>
              <div className="col-sm-12 col-md-2 col-lg-2">
                <div class="form-group mb-3">
                  <label
                    class="form-label"
                    for="exampleFormControlSelect1"
                    style={{ color: "rgb(60, 210, 165)" }}
                  ></label>
                  <select
                    class="form-select"
                    name="year"
                    onChange={onHandlerType}
                    style={{ color: "rgb(60, 210, 165)" }}
                  >
                    {Array(Number(new Date().getFullYear()) - 2022)
                      .fill(2023)
                      .map((v, index) => {
                        return (
                          <>
                            <option
                              value={Number(v) + Number(index)}
                              selected={
                                Number(new Date().getFullYear()) ===
                                Number(v) + Number(index)
                              }
                            >
                              {Number(v) + Number(index)}
                            </option>
                          </>
                        );
                      })}
                  </select>
                </div>
              </div>
              <div className="col-sm-12 col-md-2 col-lg-2">
                <div class="form-group mb-3">
                  <label
                    class="form-label"
                    for="exampleFormControlSelect1"
                    style={{ color: "rgb(60, 210, 165)" }}
                  ></label>
                  <select
                    class="form-select"
                    name="month"
                    id="exampleFormControlSelect1"
                    onChange={onHandlerType}
                    style={{ color: "rgb(60, 210, 165)" }}
                  >
                    {Array(12)
                      .fill(1)
                      .map((v, index) => {
                        return (
                          <>
                            <option
                              value={Number(v) + Number(index) - 1}
                              selected={Number(new Date().getMonth()) === index}
                            >
                              {months[index]}
                            </option>
                          </>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div className="col-2">
                <label class="form-label" for="Location"></label>
                <br />
                <button
                  type="button"
                  class="btn btn-theme"
                  // onClick={() =>
                  //   apiDataWithPagination(
                  //     { ...ref4.current.dataTable2Params },
                  //     ref4.current.callBack2,
                  //     ref4.current.companyName,
                  //     ref4.current.department,
                  //     ref4.current.year,
                  //     ref4.current.month,
                  //     ref4.current.employeeId,
                  //     true,
                  //   )
                  // }
                  onClick={() => {
                    if (!validateFilters()) return;

                    apiDataWithPagination(
                      { ...ref4.current.dataTable2Params },
                      ref4.current.callBack2,
                      ref4.current.companyName,
                      ref4.current.department,
                      ref4.current.year,
                      ref4.current.month,
                      ref4.current.employeeId,
                      true,
                    );
                  }}
                >
                  Search
                </button>
              </div>
            </div>

            {state.tableLoader && (
              <>
                <Loader />
              </>
            )}

            <div className="col-12">
              {/* {<DataTable2 headers={state.tbHeader} image={true}  reverse={true} count={"paginationTable9"} ajax={apiDataWithPagination} onDetails={onDetails} isLoading={state.dataTableLoader}/>} */}
              <DataTable
                headers={state.tbHeader}
                data={state.data}
                image={true}
                updated={state.updated}
              />
            </div>
          </div>
          <div className="card-arrow">
            <div className="card-arrow-top-left" />
            <div className="card-arrow-top-right" />
            <div className="card-arrow-bottom-left" />
            <div className="card-arrow-bottom-right" />
          </div>
        </div>
        <div class="modal" id="showImg">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div class="modal-body">
                {state.tableLoader2 && <Loader />}
                {
                  <DataTable2
                    headers={state.tbHeader2}
                    data={state.data2}
                    image={true}
                    reverse={true}
                    count={"paginationTable10"}
                    ajax={apiData2WithPagination}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <Loader />
      </>
    );
  }
};
